import { ColumnBib, ColumnStartOrder, ColumnNoc, ColumnName, ColumnExpander } from "components/common/TableColumns"
import { ColumnRound, ColumnTotalPoints } from "components/sports/sjp/events/individual/resultsFinal/Columns"
import Label from "components/general/Label"
import { findArray } from 'helpers/utils'


export function ColumnJumpDistance({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'LabelJumpDistance', 
}) {

    return (
        {
            Header: <Label data={label} sport={'SJP'}/>,
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'jumpDistance',
            Cell: (props) => {
                let row = props.cell.row.original
                let val = findArray(row.extendedResults, { er_code: ['DIST'] })?.er_value
                return val
            },


        }
    )
}

export function TableColumns1Round() {

    return (
        [
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnJumpDistance({}),
            ColumnTotalPoints({}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumns1RoundSM() {

    return (
        [
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnJumpDistance({}),
            ColumnTotalPoints({}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsFinalRound() {

    return (
        [
            ColumnStartOrder({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnRound({ roundNumber: "0" }),
            ColumnRound({ label: "HeaderFinalRound", roundNumber: "1" }),
            ColumnTotalPoints({}),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsFinalRoundSM() {

    return (
        [
            ColumnStartOrder({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnRound({ roundNumber: "0" }),
            ColumnRound({ label: "HeaderFinalRound", roundNumber: "1" }),
            ColumnTotalPoints({}),
            ColumnExpander({})
        ]
    )
}

export default TableColumns1Round

